/* eslint-disable react/style-prop-object */
import { Button, Poptip } from "@optimizely/axiom";

export const ButtonCTA = ({
    className,
    disabled,
    onClick,
    actionText,
    tooltip
}: {
    className?: string;
    disabled?: boolean;
    onClick: () => void;
    actionText?: string;
    tooltip?: string;
}) => {
    const button = (
        <Button style="highlight" isDisabled={disabled} onClick={onClick}>
            {actionText || "Add Access..."}
        </Button>
    );

    if (tooltip) {
        return (
            <Poptip isInline trigger="mouseenter" content={tooltip} className={className}>
                {button}
            </Poptip>
        );
    }

    return button;
};

ButtonCTA.displayName = "ButtonCTA";
